import React, { useState, useRef } from "react";
import styles from "./styles.module.scss";
import Slyde1 from "./Carrousel/Slide1";
import Slyde2 from "./Carrousel/Slide2";
import Slyde3 from "./Carrousel/Slide3";
import NavBar from "./NavBar";
import styled from "styled-components";
import { useScrollDirection } from 'react-use-scroll-direction'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay, EffectCreative } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import "swiper/css/effect-creative";
import { Link } from "react-router-dom";

const StyledBurger = styled.div`
  width: 2rem;
  height: 2rem;
  margin-right: 0rem;
  z-index: 20;
  display: none;
  /* display: flex; */
  justify-content: space-around;
  flex-flow: column nowrap;
  display: ${({ hidden }) => (hidden ? "none" : "flex")};
  cursor: pointer;
  div {
    width: 2rem;
    height: 0.25rem;
    background-color: ${({ open }) => (open ? "#ccc" : "#fff")};
    border-radius: 10px;
    transform-origin: 1px;
    transition: all 0.3s linear;
    &:nth-child(1) {
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }
    &:nth-child(2) {
      transform: ${({ open }) => (open ? "translateX(100%)" : "translateX(0)")};
      opacity: ${({ open }) => (open ? 0 : 1)};
    }
    &:nth-child(3) {
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }
  }
`;

const IMG = styled.div`
    img{
        visibility: ${({ open }) => (open ? "hidden" : "visible")}; 
        display: ${({ hidden }) => (hidden ? "none" : "block")};
        cursor: pointer;
        
    }
   
`;

function Header(props) {
  const intro = useRef(props.intro)
  const services = useRef(props.services)
  const processus = useRef(props.processus)
  const value = useRef(props.value)
  const contact = useRef(props.contact)
  const processusPhone = useRef(props.processusPhone)

  const { isScrollingDown } = useScrollDirection()

  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  return (
    <>
      {open === true && (isScrollingDown) && [setOpen(false), setHidden(true)]}
      {hidden === false && (isScrollingDown) && [setOpen(false), setHidden(true)]}
      {hidden === true && (window.pageYOffset === 0) && [setHidden(false)]}
      <section className={styles.container}>

        <div className={styles.navBar}>
          <div className={styles.navBar_flex_box}>


            <IMG open={open} hidden={hidden}>

                <img src="/images/logo.png" alt="logo" />

            </IMG>

            <StyledBurger open={open} onClick={() => setOpen(!open)} hidden={hidden}>
              <div />
              <div />
              <div />
            </StyledBurger>
            <NavBar open={open} intro={intro} services={services} processus={processus} value={value} contact={contact} processusPhone={processusPhone} />

          </div>
        </div>

        <div className={styles.slider}>
          <Swiper

            modules={[Navigation, Pagination, Scrollbar, Autoplay, EffectCreative]}
            spaceBetween={0}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000, disableOnInteraction: true }}
            creativeEffect={{
              prev: {
                shadow: true,
                translate: ["-125%", 0, -800],
                rotate: [0, 0, -90],
              },
              next: {
                shadow: true,
                translate: ["125%", 0, -800],
                rotate: [0, 0, 90],
              },
            }}

          >
            <SwiperSlide><Slyde1 intro={intro} /></SwiperSlide>
            <SwiperSlide><Slyde2 services={services} /></SwiperSlide>
            <SwiperSlide><Slyde3 contact={contact} /></SwiperSlide>

          </Swiper>
        </div>

      </section>
    </>
  );
}

export default Header;